import React, { useState } from 'react';
import './biografiaTesis.css';
import { useTranslation } from "react-i18next";

const BiografiaTesis = () => {
    const [t, i18n] = useTranslation("sobre_mi");

    const [currentIndex, setCurrentIndex] = useState(0);
    const images = [
        { src: "https://www.ricardosalinas.com/images/tesis/Img2.jpg", alt: "RBS Tésis" },
        { src: "https://www.ricardosalinas.com/images/tesis/img3.jpg", alt: "RBS Tésis" },
        { src: "https://www.ricardosalinas.com/images/tesis/img4.jpg", alt: "RBS Tésis" },
        { src: "https://www.ricardosalinas.com/images/tesis/img5.jpg", alt: "RBS Tésis" }
    ];

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };


    return (
        <div className='tesis-div'>
            <section className="container cuerpo-txt biografia tesis">
                <h2>
                    <div dangerouslySetInnerHTML={{ __html: (t('tesis.title1')) }} />
                    <br /><br /></h2>
                <p>
                    <div dangerouslySetInnerHTML={{ __html: (t('tesis.txt1')) }} />
                </p>
                <p>
                    <div dangerouslySetInnerHTML={{ __html: (t('tesis.txt2')) }} />
                </p>
                <div className='tesis-div-half'>
                    <div className='tesis-div-1'>
                        <img src='https://ricardosalinas.com/blog/images/Tesis-Doctorado_page-0011-4.jpg'></img>
                    </div>
                    <div className='tesis-div-2'>
                        <p>
                            <div dangerouslySetInnerHTML={{ __html: (t('tesis.txt3')) }} />
                        </p>
                        <p>
                            <div dangerouslySetInnerHTML={{ __html: (t('tesis.txt4')) }} />
                        </p>
                    </div>
                </div>

                <div className='tesis-div-half-2'>
                    <div className='tesis-div-1'>
                        <p>
                            <div dangerouslySetInnerHTML={{ __html: (t('tesis.txt5')) }} />
                        </p>

                        <p>
                            <div dangerouslySetInnerHTML={{ __html: (t('tesis.txt6')) }} />
                        </p>

                    </div>
                    <div className='tesis-div-2'>

                        <img src='https://ricardosalinas.com/blog/images/Tesis-Doctorado_page-0011-2.jpg'></img>
                    </div>
                </div>

                <p>
                    <div dangerouslySetInnerHTML={{ __html: (t('tesis.txt7')) }} />

                </p>

                <p className='espacio-arriba' style={{ textAlign: 'center' }}>
                    <a className='link-tesis' href={t('tesis.liga')} target="_blank" rel="noopener noreferrer">
                        <img src="https://www.ricardosalinas.com/images/pdf-icon.png" alt="RBS Tésis" className="img-fluid pdf-icon" />
                        <div dangerouslySetInnerHTML={{ __html: (t('tesis.btn1')) }} />

                    </a>
                </p>
            </section>

            <div className="carousel">
                <div className="carousel-inner" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                    {images.map((image, index) => (
                        <div key={index} className={`carousel-item ${index === currentIndex ? 'active' : ''}`}>
                            <img src={image.src} alt={image.alt} className="img-fluid" />
                        </div>
                    ))}
                </div>
                <button className="carousel-control-prev" onClick={handlePrev}>
                    <span className="carousel-control-prev-icon" aria-hidden="true">&#9664;</span>
                    <span className="sr-only">Previous</span>
                </button>
                <button className="carousel-control-next" onClick={handleNext}>
                    <span className="carousel-control-next-icon" aria-hidden="true">&#9654;</span>
                    <span className="sr-only">Next</span>
                </button>
            </div>
        </div>
    );
};

export default BiografiaTesis;